import React from 'react';
import { toast } from 'sonner';
import { Panel, Empty, StatusBadge, Disclaimer } from '../../components/Primitives';
import { useFetch } from '../../lib/hooks';
import { api, errMsg, fmtDate } from '../../lib/api';

const MODES = ['auto', 'manual', 'hybrid'];

export default function AdminAutomation() {
  const { data: rows, reload } = useFetch('/admin/automation');

  const update = async (key, patch) => {
    try { await api.put(`/admin/automation/${key}`, patch); toast.success('Automation updated'); reload(); }
    catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div className="space-y-6" data-testid="admin-automation">
      <Panel title="Automation Center">
        <p className="text-sm text-vj-grey mb-4">Independently configure each operational workflow as Automatic, Manual, or Hybrid, and enable or pause it. Changes persist and are recorded in the audit log.</p>
        <div className="grid gap-3 md:grid-cols-2">
          {(rows || []).map((r) => (
            <div key={r.key} className="rounded-lg border border-border p-4" data-testid={`automation-${r.key}`}>
              <div className="flex items-center justify-between mb-3">
                <div className="text-sm font-medium">{r.label}</div>
                <StatusBadge status={r.enabled ? (r.status || 'healthy') : 'paused'} />
              </div>
              <div className="flex items-center justify-between gap-3">
                <div className="flex gap-1">
                  {MODES.map((m) => (
                    <button key={m} onClick={() => update(r.key, { mode: m })} className={`h-8 px-3 rounded-md text-xs capitalize transition-colors ${r.mode === m ? 'bg-vj-neon/15 text-vj-neon border border-vj-neon/30' : 'border border-border text-vj-grey'}`} data-testid={`mode-${r.key}-${m}`}>{m}</button>
                  ))}
                </div>
                <button onClick={() => update(r.key, { enabled: !r.enabled })} className={`h-8 px-3 rounded-md text-xs ${r.enabled ? 'bg-vj-red/15 text-vj-red' : 'bg-vj-neon/15 text-vj-neon'}`} data-testid={`toggle-${r.key}`}>
                  {r.enabled ? 'Pause' : 'Enable'}
                </button>
              </div>
              {r.last_run && <div className="text-[11px] text-vj-grey mt-2">Last run: {fmtDate(r.last_run)}</div>}
            </div>
          ))}
        </div>
        {(!rows || !rows.length) && <Empty>Loading automation modules…</Empty>}
      </Panel>
      <Disclaimer>Each control is connected to backend logic, enforces role permissions, and records configuration changes. Fully-automatic deposit crediting and allocation apply only when the respective module is set to Auto and enabled.</Disclaimer>
    </div>
  );
}
